<div id="backButtonContainer">
  <button mat-icon-button (click)="backToCollaboratorView()" (keydown.enter)="backToCollaboratorView()">
    <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
  </button>
</div>
<div id="nameAndButtonContainer" class="flexRowContainer justifyContentSpaceBetween">
  <p class="headline-small">{{ documentHal?.title }}</p>
  <div class="flexRowContainer justifyFlexEnd">
    @if (restoreLink) {
      <button mat-button (click)="resetToForm()" (keydown.enter)="resetToForm()">
        <mat-icon class="material-symbols-outlined">edit</mat-icon>
        <span>{{ 'collaborator.previewPdfMetadata.buttons.edit' | translate }}</span>
      </button>
    }
    @if (downloadLink) {
      <button mat-flat-button (click)="downloadPdf()" (keydown.enter)="downloadPdf()">
        <mat-icon class="material-symbols-outlined">download</mat-icon>
        <span>{{ 'collaborator.previewPdfMetadata.buttons.download' | translate }}</span>
      </button>
    }
  </div>
</div>
